<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../assets/images/pop/dd/dingd.jpg" class="createNxs createNx1" v-if="status==1">
      <div class="createNxbtn" @click="nextcreateNx(status)">
        {{status==1?"我知道了":"我知道了"}}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]" />
    <!---------------------------------------------------项目信息-------------------------------------------------------------------->
    <div class="h-piece" style="margin:20px">
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>订单信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order" class="demo-ruleForm h-formbLine">

              <el-form-item label="订单类型" class="h-elformWrap-2">
                <el-input v-model="xsqyStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="this.order.cuname" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建时间" class="h-elformWrap-2">
                <el-input v-model="this.order.cdate" readonly></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>客户信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form1" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item prop="soldToName" label="售达方名称" :rules="[
								  { required: true, message: '请输入售达方名称', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                  <i v-if="selectDailishang" class="el-icon-search el-input__icon" slot="suffix" @click="openShoudf">
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2" v-if="!showIsFree">
                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
              </el-form-item>
              <el-form-item prop="salesregion" label="销售区域" :rules="[
								  { required: true, message: '请输入销售区域', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-select v-model="order.salesregion" placeholder="请选择" @change="changeArea($event)" style="width:100%">
                  <el-option v-for="item in salesregionNameListFilter" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[
								  { required: true, message: '请输入客户渠道', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-select v-model="order.customerChannelCode" placeholder="请选择" @change="cleanOrder($event)" style="width:100%">
                  <el-option v-for="item in customerChannelListFilter" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="isStockUp" label="是否备货" :rules="[
								  { required: true, message: '请输入是否备货', trigger: 'change'},
								]" class="h-elformWrap-2" v-if="!showIsFree&&!showRent">
                <brselect clearable category="shifou_keyong" :v="order.isStockUp" v-model="order.isStockUp"></brselect>
              </el-form-item>
              <el-form-item label="收货单位" prop="toCompanyname" class="h-elformWrap-z" :clearable="true" :rules="[
								  { required: true, message: '请输入选择单位', trigger: 'blur'},
								]" v-if="!guanliren">
                <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:165px" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                  <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收货单位"  class="h-elformWrap-z" :clearable="true" v-if="guanliren">
                <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:165px" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                  <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="h-elformWrap-m" :clearable="true">
                <i class="el-icon-circle-plus" @click="createAddress"></i>
              </el-form-item>
              <el-form-item prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'blur'},
								]" class="h-elformWrap-2">
                <el-input v-model="order.contactName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="选择收货地址" readonly :rules="[{ required: true, message: '请输入选择收货地址', trigger:['change', ' blur','input']},]" prop="toAddress" class="h-elformWrap-2">
                <el-input clearable v-model="order.toAddress" readonly style="width:100%;">
                  <i class="el-icon-search el-input__icon" slot="suffix" @click="selectAreadialog">
                  </i>
                </el-input>
              </el-form-item>

              <el-form-item label="联系电话" width="300" :rules="[
								  { required: true, message: '请输入联系电话', trigger:['change', ' blur','input']},
								  { required: true, pattern: /^((\d+-\d+?)|(\d+))$/, message: '请输入正确的电话号码', trigger: 'blur' }
								]" class="h-elformWrap-2" prop="firsttelephone">
                <div class="block">
                  <el-input v-model="order.firsttelephone" placeholder="请输入"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="期望收货日期" class="h-elformWrap-2" width="100%" :rules="[
								  { required: true, message: '请先选择收货地址', trigger: 'blur'},
								]" prop="receivedTime" v-if="!guanliren">
                <div class="block">
                  <el-date-picker v-model="order.receivedTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择期望收货日期--">
                  </el-date-picker>
                </div>
              </el-form-item>

              <el-form-item prop="currencyCode" label="币种" :rules="[
								  { required: true, message: '请输入币种', trigger: 'change'},
								]" class="h-elformWrap-2">
                <mdmselect clearable category="YLCurrency" :showcode="true" disabled :v="order.currencyCode" v-model="order.currencyCode"></mdmselect>
              </el-form-item>

              <el-form-item prop="kucun" label="库位" v-if="this.order.orderCategory1 == '14'" class="h-elformWrap-2">
                <brselect clearable category="order_tuihuo_kuwei" :v="order.kucun" v-model="order.kucun"></brselect>
              </el-form-item>

              <el-form-item prop="kucun" label="库位" :rules="[{ required: true, message: '请选择库位', trigger:['change', 'blur']},]" v-if="this.order.orderCategory1 == '6'" class="h-elformWrap-2">
                <brselect clearable category="nx_mianfei_kuwei" :v="order.kucun" v-model="order.kucun"></brselect>
              </el-form-item>

              <el-form-item prop="dataWire" label="退货方式" class="h-elformWrap-2">
                <el-select v-model="order.dataWire" placeholder="请选择" style="width:100%">
                  <el-option label="退货退款" value="退货退款"></el-option>
                </el-select>
              </el-form-item>

<!--              <el-form-item label="是否协同收入" class="h-elformWrap-2" v-if="!showXietong" required >-->
<!--                <brselect clearable category="is_xietong" :v="order.isXietong" v-model="order.isXietong"></brselect>-->
<!--              </el-form-item>-->

              <!-- 附件上传 -->
              <el-form-item v-if="(this.order.orderCategory1 == '1' || this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11')&& agentLevel!=2" label="战略附件" class="h-elformWrap-2">
                <brupload v-model="order.sgFileUrl" :refid=testID reftype="NX_ZLXY" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                </brupload>
              </el-form-item>

              <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;" v-if="(this.order.orderCategory1 == '1' || this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11')">订单为异地发货时，必须选择是否战略以及上传战略附件！！</h6>

            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <!--------------------------------退货信息--------------->
      <!--            <div class="h-pieceIn2">-->
      <!--                <div class="h-pieceTitle2" style="margin-left:10px;">-->
      <!--                    <h1>退货信息</h1>-->
      <!--                </div>-->
      <!--                <div class="h-pieceCon2">-->
      <!--                    <div class="h-formLine n-two">-->
      <!--                        <el-form :model="order" ref="form2" label-position="right" :inline="true"-->
      <!--                                 class="demo-ruleForm h-formbLine">-->
      <!--                            <el-form-item prop="tuihyydes" label="退货方式" class="h-elformWrap-2">-->
      <!--                                <el-select v-model="order.returnMethod" placeholder="请选择" :disabled='true' style="width:100%">-->
      <!--                                    <el-option label="退货退款" value="1"></el-option>-->
      <!--                                </el-select>-->
      <!--                            </el-form-item>-->
      <!--                        </el-form>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!-------------------------------------------------------退货产品信息-------------------------------------------------------------------->
      <div>
        <div class="h-table h-mrt30 ljjtablepaddings2" style="margin: 20px 20px 0 10px;">
          <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
            <h1 class="h1">退货产品信息</h1>
            <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" v-if="!mzFlag" @click="showProcuct3">选择退回产品
            </el-button>
            <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" v-if="mzFlag" @click="showProcuct2">选择买赠订单
            </el-button>
          </div>
          <div v-for="(obj,index) in companyInfoList" :key="index">
            <div v-if="getProductlist(obj.code).length>0" style="margin-bottom: 20px;">
              <span style="color: #4a4a4a" v-if="!chooseGscode">{{ obj.name }}</span>
              <el-select v-model="zhidanGsCode" placeholder="请选择" @change="chooseGsCode($event),$forceUpdate()" style="width:320px" v-if="chooseGscode">
                <el-option v-for="item in zhidanCompanycode" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
              <el-form label-position="right" :inline="true" :ref="'form'+obj.code" :model="order" class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
                <el-form-item label="成本中心" :prop="'costCenter'+obj.code" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;" :rules="[
                        { required: true, message: '请选择成本中心', trigger: 'change'},
                    ]">
                  <el-select v-model="order['costCenter'+obj.code]" style="width: 350px;" clearable filterable placeholder="--选择--">
                    <el-option v-for="item in getCostList(obj.code)" :key="item.index" :label="`${item.costCenterCode} : ${item.remark}`" :value="item.costCenterCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-table ref="multipleTable" :data="getProductlist(obj.code)" stripe border v-loading="Productlistloading" show-summary :key='Productlistnum' style="width: 100%">
                <el-table-column type="index" label="#" width="30">
                </el-table-column>
                <el-table-column prop="billingStarttime" label="开票开始日期" v-if="showJzx" :show-overflow-tooltip="true" width="150">
                  <template slot-scope="scope">
                    <div class="block">
                      <el-date-picker v-model="scope.row.billingStarttime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择开票开始日期--">
                      </el-date-picker>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="billingEndtime" label="开票结束日期" v-if="showJzx" :show-overflow-tooltip="true" width="150">
                  <template slot-scope="scope">
                    <div class="block">
                      <el-date-picker v-model="scope.row.billingEndtime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择开票结束日期--">
                      </el-date-picker>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="proModelName" label="产品大类" :show-overflow-tooltip="true" width="80">
                </el-table-column>
                <el-table-column min-width="150" prop="shareModelCode" v-if="!secondAgent" :show-overflow-tooltip="true" label="共享大类">
                  <template slot-scope="scope">

                    <el-select class="h-tableInput" v-if="scope.row.proType=='OEM'&&scope.row.smList.length>0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" placeholder="请选择" clearable>
                      <el-option v-for="item in scope.row.smList" :key="item.shareModelCode" :label="item.shareModelName" :value="item.shareModelCode">
                      </el-option>
                    </el-select>
                    <el-select class="h-tableInput" v-if="scope.row.proType!='OEM'||scope.row.smList.length==0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" disabled placeholder="请选择" clearable>

                    </el-select>
                    <!--<brselect :v="scope.row.shareModelCode"  v-if="scope.row.proType=='OEM'" style="width:1.5rem" category="product_level" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)"
                                        clearable placeholder="&#45;&#45;请选择&#45;&#45;"></brselect>-->

                  </template>
                </el-table-column>
                <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="95">
                </el-table-column>
                <el-table-column min-width="150" prop="materialName" :show-overflow-tooltip="true" label="产品名称">
                  <template slot-scope="scope">
                    <div style="text-align: left;">
                      {{scope.row.materialName}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="150" prop="oemDesc" :show-overflow-tooltip="true" label="规格型号">
                  <template slot-scope="scope">
                    <div style="text-align: left;">
                      {{scope.row.oemDesc}}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="factory" label="产地" :show-overflow-tooltip="true" width="60">
                </el-table-column>

                <el-table-column prop="ycid" label="退货订单号" v-if="!mzFlag" min-width="140">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.ycid" @blur="getSapCodeTh(scope.row,scope.$index)" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="ycid" label="退货订单号" v-if="mzFlag" min-width="140">
                  <template slot-scope="scope">
                    {{scope.row.ycid}}
                    <!--                                <el-input-->
                    <!--                                    v-model.number="scope.row.ycid" @change="" @blur="getSapCodeTh(scope.row,scope.$index)"-->
                    <!--                                    placeholder="请输入"-->
                    <!--                                    class="DshuR h-tableInput" auto-complete="off"></el-input>-->
                  </template>
                </el-table-column>

                <el-table-column prop="proNumberTh" label="退货订单产品数量" :show-overflow-tooltip="true" width="80">
                  <template slot-scope="scope">
                    {{scope.row.proNumberTh}}
                  </template>
                </el-table-column>

                <el-table-column prop="surplusNum" label="剩余数量" :show-overflow-tooltip="true" width="60">
                  <template slot-scope="scope">
                    {{scope.row.surplusNum}}
                  </template>
                </el-table-column>

                <el-table-column prop="proNumber" label="退货数量" v-if="!mzFlag" width="80">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.proNumber" placeholder="请输入" class="DshuR h-tableInput" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" auto-complete="off"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="proNumber" label="退货数量" v-if="mzFlag" width="80">
                  <template slot-scope="scope">
                    {{scope.row.proNumber}}
                  </template>
                </el-table-column>

                <el-table-column prop="cwddh" label="财务订单号" v-if="showRent" min-width="140">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.cwddh" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="currencyCode" label="币种" :show-overflow-tooltip="true" v-if="!secondAgent && showJzx" width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">
                      {{scope.row.currencyCode}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="priceType" label="费用名称" v-if="showJzx" width="150" :show-overflow-tooltip="true">
                  <template scope="scope">
                    <brselect clearable category="price_type" :v="scope.row.priceType" @change="getRentPrice(scope.row.priceType,scope.$index)" v-model="scope.row.priceType"></brselect>
                  </template>
                </el-table-column>
                <el-table-column prop="proBenchmarkPrice" :label="priceName" :show-overflow-tooltip="true" v-if="!secondAgent" width="70">
                  <template slot-scope="scope">
                    <div style="text-align: right;">
                      {{(scope.row.proBenchmarkPrice = new
                      big(scope.row.finalPrice||0).toFixed(2).toString())}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="cgmll" label="毛利率" :show-overflow-tooltip="true" v-if="showShcgmll" width="90">
                  <template slot-scope="scope">
                    {{scope.row.cgmll | numFilter}}
                  </template>
                </el-table-column>
                <el-table-column v-if="showSamplePro" prop="discount" label="打折级别" width="90">
                  <template slot-scope="scope">
                    <brselect class="h-tableInput" category="sample_product_discount" :v="scope.row.discount" v-if="!isA33" v-model="scope.row.discount" />
                    <brselect class="h-tableInput" category="sample_product_discount_a33" :v="scope.row.discount" v-if="isA33" v-model="scope.row.discount" />
                  </template>
                </el-table-column>
                <el-table-column v-if="tejieshowflag" prop="specialPrice" label="特价" width="120">
                  <template slot-scope="scope">
                    <el-select class="h-tableInput" v-model="scope.row.specialOfferCode" @change="changeTejia($event,scope.row)" placeholder="请选择" clearable>
                      <el-option v-for="item in scope.row.tjlist" :key="item.tjdtid" :label="item.tejia" :value="item.tjdtid">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column v-if="tejieshowflag" prop="tjid" label="特价版本号" :show-overflow-tooltip="true" width="160">
                </el-table-column>
                <el-table-column v-if="tejieshowflag" prop="specialPriceNum" label="特价余量" :show-overflow-tooltip="true" width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">
                      {{scope.row.specialPriceNum}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="dingzhishowflag" prop="extraDes" label="定制需求" width="150">
                  <template scope="scope">
                    <el-select class="h-tableInput" v-model="scope.row.extraDes" style="width:1.5rem;" allow-create filterable default-first-option @change="changeDingzhi(scope.row)" clearable>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column v-if="dingzhishowflag" prop="extraPrice" label="定制加价" width="120">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.extraPrice" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="成交价"
                        min-width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.finalPrice"
                              placeholder="请输入"
                              @keyup.native='keyupEvent($event,input)'
                              class="DshuR h-tableInput" auto-complete="off"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="jinejjz" label="净价值" width="70">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{ scope.row.jinejjz = new
                                big(scope.row.finalPrice||0).div(scope.row.taxRate||0).toFixed(2).toString()}}</div>
                  </template>
                </el-table-column>

                <!--                          <el-table-column
                              prop="jinejjz"
                              label="净价值"
                              v-if="mzFlag"
                              width="70">
                            <template slot-scope="scope">
                              <div style="text-align: right;">{{ scope.row.jinejjz}}</div>
                            </template>
                          </el-table-column>-->

                <el-table-column prop="totalprice" label="总价" width="70">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber ||
                                    0).times((scope.row.proBenchmarkPrice||0)).toFixed(2).toString() }}</div>
                  </template>
                </el-table-column>
                <el-table-column  label="业务类型" v-if="guanliren" min-width="100">
                <template slot-scope="scope" v-if="scope.row.proType=='OEM'">
                  <el-select v-model="scope.row.zhifakufa" :clearable="true" disabled placeholder="请选择">
                    <el-option label="直发" :value="1"></el-option>
                    <el-option label="库发" :value="2"></el-option>
                  </el-select>
                </template>
              </el-table-column>
                <el-table-column prop="totalpriceTh" label="退货总价" width="100">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{ scope.row.totalpriceTh = new big(scope.row.proNumber ||
                                    0).times((scope.row.finalPrice||0)).toFixed(2).toString() }}</div>
                  </template>
                </el-table-column>
                <!--                          <el-table-column
                              prop="mzFlag"
                              label="总价"
                              v-if="!secondAgent"
                              width="70"
                          >
                            <template slot-scope="scope">
                              <div style="text-align: right;">{{ scope.row.totalprice}}</div>
                            </template>
                          </el-table-column>-->

                <!--                            <el-table-column
                                prop="isMaizeng"
                                label="是否买赠"
                                v-if="mzFlag"
                                width="100"
                            >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.isMaizeng" :clearable="true"
                                        placeholder="请选择" disabled>
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                                </el-select>
                            </template>
                            </el-table-column>-->
                <el-table-column prop="note1" label="备注" min-width="160">
                  <template slot-scope="scope">
                    <el-input class="h-tableInput" v-model="scope.row.note1" placeholder="请输入" auto-complete="off"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteThis(scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="jieguo w-newIcon" v-if="mzFlag" v-show="mzFlag">
                <span class="jieguo_label"></span>
                <span class="jieguo_value"></span>
                <span class="jieguo_label">净价值</span>
                <span class="jieguo_value">{{ getOrderName(obj.code).orderNetWorth }}</span>
                <span class="jieguo_label">订单总价</span>
                <span class="jieguo_value">{{ getOrderName(obj.code).orderPriceTh }}</span>
                <span class="jieguo_label">退货总价</span>
                <span class="jieguo_value">{{ getOrderName(obj.code).orderPrice }}</span>
              </div>
            </div>
          </div>
          <!-- <el-table
                            ref="multipleTable"
                            :data="productlist2"
                            stripe
                            border
                            style="width: 100%">
                        <el-table-column
                                fixed
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>

                        <el-table-column
                                min-width="150"
                                prop="shareModelCode"
                                v-if="!secondAgent"
                                :show-overflow-tooltip="true"
                                label="共享大类">
                            <template slot-scope="scope">
                                <el-select class="h-tableInput" v-if="scope.row.proType=='OEM'&&scope.row.smList.length>0" v-model="scope.row.shareModelCode"
                                           @change="changeShareModel($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                            v-for="item in scope.row.smList"
                                            :key="item.shareModelCode"
                                            :label="item.shareModelName"
                                            :value="item.shareModelCode">
                                    </el-option>
                                </el-select>
                                <el-select class="h-tableInput" v-if="scope.row.proType!='OEM'||scope.row.smList.length==0" v-model="scope.row.shareModelCode"
                                           @change="changeShareModel($event,scope.row)" disabled
                                           placeholder="请选择" clearable>

                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                :show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                :show-overflow-tooltip="true"
                                label="产品名称">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                min-width="150"
                                prop="oemDesc"
                                :show-overflow-tooltip="true"
                                label="规格型号">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.oemDesc}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                width="100">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.proNumber"
                                        placeholder="请输入"
                                        class="DshuR h-tableInput" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                label="基准价"
                                :show-overflow-tooltip="true"
                                width="90">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.proBenchmarkPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="currencyCode"
                                label="币种"
                                v-if="!secondAgent && showJzx"
                                :show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="priceType"
                                label="费用名称"
                                v-if="showJzx"
                                width="150"
                                :show-overflow-tooltip="true">
                            <template scope="scope">
                                <brselect clearable category="price_type"  :v="scope.row.priceType" disabled="true"
                                          v-model="scope.row.priceType"></brselect>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
                                width="100">
                            <template slot-scope="scope">
                                <el-input
                                        v-model.number="scope.row.finalPrice"
                                        placeholder="请输入"
                                        class="DshuR h-tableInput" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalprice"
                                label="总价"
                                :show-overflow-tooltip="true"
                                width="90">
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{ (scope.row.totalprice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice
                                    || scope.row.proBenchmarkPrice || 0)).toFixed(2).toString())}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        v-model="scope.row.id"
                                        @click="deleteThis2(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table> -->
        </div>
      </div>

      <shouorder :visible.sync="showwuliaodialog1" v-if="showwuliaodialog1" title="订单" @choseObj="choseOrder" />
      <!--物料-->
      <wxwl :visible.sync="showwuliaodialog2" v-if="showwuliaodialog2" @choseObj="choseWuliao1" :usercode="order.soldToCode" :ddlx="ddlx" :xmcode="xmcode" :currencyCode="order.currencyCode" :customerChannelCode="order.customerChannelCode" :areaCode="order.salesregion" title="选择物料" />
      <!--售达方-->
      <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag :usercode="currentUser" :xmcode="xmcode" :ddlx="ddlx" :xszz="order.saleGroupCode" title="选择售达方" />
      <!--地址信息-->
      <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
    </div>
    <div v-if="taskstatus=='0'">
      <div class="anniu" v-if="!resubmit">
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
        </el-row>
      </div>
      <div class="anniu" v-else>
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
          <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </el-row>
      </div>
    </div>
    <div class="anniu" v-if="taskstatus == '1'">
      <el-row>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="this.$store.dispatch('backToTaskIndex')">返回</el-button>
      </el-row>
    </div>
    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="institutionalX" class="h-dialog2">
      <companyName ref="companyName" :titleName="titleDig" :add1="add" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
    </el-dialog>
    <!--        <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>{{titleDig}}</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
&lt;!&ndash;                <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">单位名称为大学时，请按实际情况维护用户分类(211/985)</h6>&ndash;&gt;
                <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                    <el-form-item  label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName" :rules="[{ required: true, message: '请输入单位名称', trigger: 'blur'},]">

                        <el-select v-model="add.deptName"  remote filterable :filter-method="selectDept" clearable placeholder="请输入" allow-create
                                   :remote-method="selectDept" @change="changeDeptName($event)">
                            <el-option v-for="(item) in deptNameList"
                                       :key="item.deptName"
                                       :label="item.deptName"
                                       :value="item.deptName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
                        <brselect category="sales_region" :v="add.deptSourceChannel" :showcode="true" @change="changeChannel($event)"
                                  v-model="add.deptSourceChannel" clearable></brselect>
                    </el-form-item>
                    <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]">
                      <el-select v-model="add.schoolTypeName"
                                 @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                        <el-option v-for="item in addressTypeList"
                                   :key="item.id"
                                   :label="item.userUnit"
                                   :value="item.userUnit">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="省" class="h-elformWrap-2" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                        <el-select v-model="add.province" @change="handleItemChange1" placeholder="省"  style="width: 68%;">
                            <el-option
                                    v-for="item in shenglist"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="市" class="h-elformWrap-2" prop="city"
                                  :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                        <el-select v-model="add.city" @change="handleItemChange2"
                                   :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                   placeholder="市"  style="width: 68%;">
                            <el-option
                                    v-for="item in arealist2"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区" class="h-elformWrap-2" prop="area"
                                  :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                        <el-select v-model="add.area"
                                   :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                   placeholder="区" style="width: 68%;" @change="handleItemChange3">
                            <el-option
                                    v-for="item in arealist3"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级" class="h-elformWrap-1" label-width="100" prop="deptName">
                        <treeselect
                                :multiple="false"
                                :options="options"
                                :flat="true"
                                :default-expand-level="1"
                                placeholder="请选择"
                                v-model="stVal"
                        />
                        <treeselect-value :value="stVal" />
                    </el-form-item>
                    <el-form-item label="详细地址" class="h-elformWrap-1"
                                  :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                                  prop="address">
                        <el-input v-model="add.address" style="width: 84%;"></el-input>
                    </el-form-item>
                </el-form>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>-->
    <el-dialog :close-on-click-modal="false" @close='closePriceDialog' :visible.sync="selectPriceDialog" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>选择费用类型</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <el-form ref="form" :model="zlPrice" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
          <el-form-item label="费用类型" class="h-elformWrap-2" label-width="100" prop="pricetype">
            <brselect category="price_type" :v="zlPrice.pricetype" v-model="zlPrice.pricetype">
            </brselect>
          </el-form-item>
        </el-form>
        <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="exitPrice">取消</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitPriceType()">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import big from 'big.js'
import ss from '../../api/SystemService'
import wxwl from '../../components/dialog/wxwl'
import shoudf from '../../components/dialog/selectshdf'
import shouorder from '../../components/dialog/selectorder'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import uploadFile from "../../api/process/account_complainUploadService";

import uploaddown from '../../utils/updownfile'
import _ from "loadsh";
import companyName from "@/components/basic/companyName.vue";
export default {
  components: {
    companyName,
    wxwl, shoudf, Treeselect, shouorder
  },
  filters: {
    gsname: function (v) {
      return _.find(this.allxszz, { code: v }).name;
    },
    numFilter (value) {
      let realVal = ''
      if (value) {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2) * 100 + '%'
      } else {
        realVal = '--'
      }
      return realVal
    }
  },
  data () {
    return {
      institutionalX: false,
      orderNu: -1,
      testID: '',
      thType: '',
      submitChongfuFlag: true,
      ydgFlag: false,
      priceName: "基准价",
      contract: "",
      showRent: false,
      showJzx: false,
      isMzFlag: false,
      showSampleHetong: false,
      contractStarttime: "",
      contractEndtime: "",
      checked: true,
      showOrhide: false,
      status: 1,
      toshow: 'createNxOrder2',
      isA33: false,
      showSamplePro: false,
      showIsFree: false,
      showIsFreeSh: false,
      resubmit: false,
      instid: null,
      taskstatus: 0,
      //时候售后订单
      showshouhouflag: false,
      showhistory: false,
      selectDailishang: true,
      showwuliaodialog1: false,
      showwuliaodialog2: false,
      showshdfdialog: false,
      showdizhiflag: false,
      currentUser: null,
      showdelProductRow: true,
      showaddProductRow: true,

      //上海的采购毛利率
      showShcgmll: false,
      //是否可以选择时间
      startDateLimit: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() + 5 * 24 * 3600 * 1000
        }
      },
      openReceivedTimedisabled: true,
      //特价
      tejieshowflag: false,
      //定制展示
      dingzhishowflag: false,
      //现金余额
      cashBalance: 0,
      //展会项目不展示合同号
      contractflag: true,
      xmcode: null,
      //销售组织
      allxszz: [],
      //订单类型
      ddlx: null,
      //是否直单用户
      zhidanflag: 0,
      companycodes: "",
      zhidanCompanycode: [],
      isBlood: 0,
      //经销商级别(一级二级)
      agentLevel: "",
      //是否二级经销商
      secondAgent: false,
      chooseGscode: false,
      //是否选择了买赠订单
      selectMz: false,
      zhidanGsCode: "",

      //行项目
      productlist9390: [],
      productlist9370: [],
      productlist1D90: [],
      productlist1JC0: [],
      productlist9391: [],
      productlist1RK0: [],
      productlist1R60: [],
      productlist0PN0: [],
      productlist1S00: [],
      productlist1S40: [],
      productlist1S30: [],
      productlist44U0: [],
      productlist45K0: [],
      allProductlist: [],
      //客户地址信息
      addrList: [],
      //对象
      order9390: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9370: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1D90: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1JC0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9391: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1RK0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1R60: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order0PN0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S00: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S40: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S30: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order44U0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order45K0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order: {
        id: null, // 主键
        orderMainContract: null, // 主合同编号
        orderSubContract: null, // 分合同编号
        orderProjectCode: null, // 项目编号
        orderProjectName: null, // 项目名称
        projectDescription: null, // 项目描述
        orderCategory: null, // 订单类型
        orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
        saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织 1D90-海乐苗（青岛）智能物联有限公司 1JC0-青岛鸿鹄航空科技有限公司
        disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
        zCode: null, // 分销渠道编码-子编码
        customerChannelCode: null, // 客户渠道
        isStockUp: null, // 是否备货      1：是；0：否
        orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
        instid: null, // 流程id
        taskId: null, // 流程id
        tuihyy: null, // 退货原因
        tuihyydes: null, // 退货原因说明
        contactName: null, // 联系人名称
        collageTypeCode: null,
        receivedTime: null, // 预计收货时间
        soldToCode: null, // 售达方编码
        soldToName: null, // 售达方名称
        salesregion: null, // 售达方销售区域
        salesregionNew: null,// 销售区域默认值
        salesregionName: null, // 售达方销售区域名称
        soldToAreaCode: null, // 售达方地区编码
        soldToAreaName: null, // 售达方地区名称
        shipToCode: null, // 送达方编码
        shipToName: null, // 送达方名称
        shipToAreaCode: null, // 送达方地区编码
        invoiceCode: null, // 开票方编码
        payerCode: null, // 付款方编码
        currencyCode: null, // 币种编码
        orderPrice: 0, // 订单总价
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        poId: null, // PO号
        areaId: null, // 区域详情表关联id
        dcCode: null, // 配送中心编码
        toProvincesCode: null, // 送达省份编码
        toCityCode: null, // 送达城市编码
        note: null, // 订单备注
        note1: null,//产品备注
        postcode: null, // 邮政编码
        firsttelephone: null, // 第一个电话
        secondtelephone: null, // 第二电话
        extraPrice: null, // 定制加价
        customized: null, // 定制需求
        sapsended: null, // 是否已提交sap,1-是,0-否
        toAddress: null, // 收货地址
        toCompanyname: null, // 送达方公司全称
        posnr: null, // 外销:销售和分销凭证的项目号
        inco1: null, // 外销:国际贸易条款 (部分1)
        inco2: null, // 外销:国际贸易条款 (部分2)
        submitflag: null,//提交标志
        categoryName: null,
        category1Name: null,
        saleGrputName: null,
        disChannelName: null,
        zcodeName: null,
        expoPrice: null,//展会价
        fktj: null, //付款条件
        costCenter9390: null,
        costCenter9370: null,
        costCenter1D90: null,
        costCenter1JC0: null,
        costCenter1RK0: null,
        costCenter9391: null,
        costCenter1R60: null,
        costCenter0PN0: null,
        costCenter1S00: null,
        costCenter1S40: null,
        costCenter44U0: null,
        costCenter45K0: null,
        businessReason: null,

        kucun: null,//库存地点
        lkfileUrl: null,
        fileUrl: [],
        sgFileUrl: null,
        csFileUrl: null,
        isStandard: '',
        isZl: '',
        mfFileUrl: null,
        agentLevel: "",
        zmFile: null,
        upload2: [],
        isChange: 0,
        isCancel: 0,
        returnTime: null,
        zltype: null,
        updateFlag: false,
        dataWire: '退货退款',
        isXietong: 0,//是否协同收入
      },
      productlist2: [],
      //客户渠道list
      customerChannelList: [],
      customerChannelListFilter: [],

      salesregionNameList: [],
      salesregionNameListFilter: [],

      lkFlag: false,
      csFlag: false,

      mfUrl: null,

      newDialog: false,
      titleDig: false,
      shenglist: [],
      arealist2: [],
      arealist3: [],
      add: {
        id: '',
        deptName: '',
        deptType: '',
        leader: '',
        phone: '',
        email: '',
        status: '',
        countryId: '',
        country: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        landmark: '',
        area: '',
        address: '',
        shengobj: '',
        shiobj: '',
        quobj: '',
        selectId: '',
        address: '',
        subFlag: '',
        deptSourceChannel: '',
        longitude: '',
        latitude: '',
        parentCode: '',
        schoolTypeName: '',
      },
      proSelect: {
        pcode: 0,
        level: 1,
      },
      rules: {
        cwddh: [
          { required: true, message: '请输入财务订单号', trigger: 'blur' },
        ],
        fileUrl: [
          { required: true, message: '请上传方案图纸', trigger: 'blur' }
        ],
        sgFileUrl: [
          { required: true, message: '请上传施工确认单', trigger: 'blur' }
        ],
        csFileUrl: [
          { required: true, message: '请上传投标参数', trigger: 'blur' }
        ]
      },
      deptNameList: [],
      addressTypeList: [],
      options: [],
      stVal: null,
      fileList2: [],
      idList: [],
      selectPriceDialog: false,
      zlPrice: {
        pricetype: null,
      },
      zlUpdateFlag: false,
      rentTimeList: [],
      //所用公司信息
      companyInfoList: [],
      mzFlag: false,
      ypjFlag: false,
      Productlistloading: false,
      Productlistnum: 0,
      guanliren:false,
      showXietong: false,
    }
  },

  //页面加载前事件
  created () {
    //所用公司信息
    this.companyInfoList = this.$store.getters.dictlist("company_info");
    // 当前权限
    this.guanliren = this.$store.getters.hasRole("swyl_xiaoshoujl_yx");
    //是否协同收入
    this.showXietong = this.$store.getters.hasRole("swyl_gndailishang,swyl_gwdailishang,swyl_xiaoshoujl,swyl_xiaoshoujl_wx,swyl_dingdgly,swyl_waixiaogly");
    //生产所有公司产品变量
    this.companyInfoList.forEach((obj) => {
      this.$set(this.allProductlist, 'productlist' + obj.code, [])
      //动态生成监听
      this.$watch('productlist' + obj.code, (newValue, oldValue) => {

        //计算退货总金额
        this['order' + obj.code].orderPriceTh = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //计算总净价值
        this['order' + obj.code].orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //计算总金额
        this['order' + obj.code].orderPrice = _.reduce(_.map(newValue, "totalpriceTh"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
      }, { deep: true, immediate: true });

    })
    //默认库存
    this.order.kucun = 'BL00'

    if (this.$route.query.id == '' || this.$route.query.id == undefined) {
      this.testID = this.$route.query.ywid
    } else {
      this.testID = this.$route.query.id
    }
    this.order.fileUrl = []
    this.order.sgFileUrl = []
    this.order.csFileUrl = []
    console.log('我在这儿呀', this.$route.query.chongXinTiJiao);
    this.showzhezhao()
    this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
    this.customerChannelList = this.$store.getters.dictlist("sales_region");
    this.salesregionNameList = this.$store.getters.dictlist("YlSalesArea_chanpin");
    let id = this.$route.query.ywid;
    console.log(this.testID)
    let instid = this.$route.query.instid;
    let taskid = this.$route.query.taskid;
    let taskstatus = this.$route.query.taskstatus | 0;
    let chongXinTiJiao = this.$route.query.chongXinTiJiao;
    //代办打开的
    if (id && instid) {
      this.resubmit = true;
      //如果不是重新提交,则不能添加跟删除了
      if (!chongXinTiJiao) {
        this.showaddProductRow = false;
        this.showdelProductRow = false;
      }

      this.instid = instid;
      this.taskstatus = taskstatus;
      this.order.taskId = taskid;
      if (taskstatus == '1') {
        // 直接设置经销商
        this.selectDailishang = false;
        const parent = document.querySelector(".input");
        parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
        //2.在设置input属性
        //获取input
        const input = document.querySelector(".input input");
        //设置input的属性为false
        input.disabled = false;
      }
    }
    this.getOrder(id || this.$route.query.id);
    // this.order.customerChannelCode = null;
    this.getParentInfo();

    //判断能否显示价格信息
    //如果不是内部用户 并且 agentLevel=2
    if (this._user.usertype != '0' && this._user.agentLevel == 2) {
      //判断是否是分销商（二级经销商）
      this.secondAgent = true;
    }
  },

  computed: {
    xsqyStr () {
      if (this.order.category2Name) {
        return this.order.categoryName + "/" + this.order.category1Name + "/" + this.order.category2Name
      } else if (this.order.category1Name) {
        return this.order.categoryName + "/" + this.order.category1Name
      }
      return this.order.categoryName
    },
  },
  watch: {
    //原逻辑删除mark


  },
  mounted () {

  },
  methods: {
    sgIsUpload (v) {
      console.log('sgIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.sgfileUrl = arrnew
        console.log(this.order.sgfileUrl)
      } else {
        this.order.sgfileUrl = []
      }
    },
    showzhezhao () {
      ss.salesList.toshow(this.toshow).then(rd => {
        console.log(rd)
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    closeIt () {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextcreateNx (i) {
      if (this.status == 1) {

        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }
    },
    getSecondOrder (id) {
      ss.SecondOrderMainService.selectSecondOrderById(id).then(rd => {
        _.assign(this.order, rd.obj)
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '') + "," + (this.order.orderCategory2 || '');
        let type = this.order.orderCategory1;
        // 判断是否是经销商,经销商自己下单
        //当前登录人，就是经销商的话
        if (this._user.usertype == '1') {
          this.order.soldToCode = this._user.usercode;
          this.selectDailishang = false;
        }
        Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
          //存在行项目
          if (rd.obj.products && rd.obj.products.length > 0) {

            rd.obj.products.forEach((obj) => {
              if (obj) {
                this.addProject(obj)
              }
              //判断是否冷库
              ss.waixiao.isLk(obj.materialCode).then(rd => {
                this.lkFlag = rd.msg;
                console.log("lkFlag", this.lkFlag)
              })
            })

          }
          if (rd.obj.isStandard == 2) {
            this.csFlag = true;
          }
        })
      })
    },
    getOrder (id) {
      ss.OrderMainService.selectById(id).then(rd => {
        _.assign(this.order, rd.obj)
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '') + "," + (this.order.orderCategory2 || '');
        //   暂时注释掉销售区域回显 让用户自己选择
        //   this.order.salesregion = rd.obj.salesregion
        //   this.order.salesregion = ''
        let type = this.order.orderCategory1;
        Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
          if (type == '1') {
            this.xmcode = this.order.orderProjectCode;
            //项目类型，一定有特价只有特价单，才有特价选择
            this.tejieshowflag = true;
          } else if (type == '7') {
            this.contractflag = false;
            this.xmcode = this.order.orderProjectCode;
          } else if (type == '4') {
            //    售后订单
            this.showshouhouflag = true;
            // 直接设置经销商
            this.selectDailishang = true;
          } else if (type == '3') {
            //    改制订单
            this.dingzhishowflag = true;
          } else if (type == '6' || type == '33') {
            //免费订单
            this.showIsFree = true;
            if (type == '33') {
              this.showIsFreeSh = true;
            }
            this.priceName = "成本价";
            //获取所有成本中心
            this.companyInfoList.forEach((obj) => {
              ss.OrderMainService.getCostCenterList({ companyCode: obj.code }).then(rd => {
                this['costList' + obj.code] = rd;
              })
            });
            //原逻辑删除mark

            //去除加载时赋值A33
            //this.order.soldToCode = "A33";
          } else if (type == '5') {
            //样品机订单
            this.showSamplePro = true;
            this.showSampleHetong = true;
          } else if (type == '8') {
            //租赁订单
            this.showRent = true;
            this.xmcode = this.order.orderMainContract;
            if (this.order.updateFlag) {
              this.zlUpdateFlag = this.order.updateFlag;
            }
            ss.contractService.detail(this.order.orderMainContract).then(rd => {
              this.contract = rd.obj;
              this.order.zsyzq = rd.obj.zsyzq;
              if (this.contract.zltype == "3") {
                this.showJzx = true;
              }
              if (this.contract.isShhm == 1) {
                this.contract.isShhm = '1';
              } else if (this.contract.isShhm == 0) {
                this.contract.isShhm = '0';
              }
              if (this.contract.isJj == 1) {
                this.contract.isJj = '1';
              } else if (this.contract.isJj == 0) {
                this.contract.isJj = '0';
              }
              if (this.order.isChange == 1) {
                this.order.isChange = '1';
              } else if (this.order.isChange == 0) {
                this.order.isChange = '0';
              }
              if (this.order.isCancel == 1) {
                this.order.isCancel = '1';
              } else if (this.order.isCancel == 0) {
                this.order.isCancel = '0';
              }
              this.order.rentDate = rd.obj.returnTime;
              this.order.zltype = this.contract.zltype;
              this.getRentTime();
              //根据合同编号和订单类型获取代理搜信息
              ss.selectUserAgent.getOneShoudf(this.contract.customerCode).then(rd => {
                this.choseshoudf(rd, true);
              })

            })

          } else if (this.ddlx == '1,11') {
            //只有特价单，才有特价选择
            this.tejieshowflag = true;
          } else if (type = 14) {
            //退货订单
            if (this.order.orderCategory2 == 0) {
              this.mzFlag = false;
            } else if (this.order.orderCategory2 == 1) {
              this.mzFlag = true;
            } else {
              this.mzFlag = false;
            }
          }
          //存在行项目
          if (rd.obj.products && rd.obj.products.length > 0) {
            //加载完现金跟信贷，在插入行项目
            Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
              rd.obj.products.forEach((obj) => {
                if (obj) {
                  if (this.ddlx == '1,4') {
                    //添加行项目
                    if (obj.orderztype == '发货单') {
                      this.addProject(obj)
                    } else if (obj.orderztype == '退货单') {
                      this.productlist2.push(obj);
                    }
                  } else {
                    this.addProject(obj)
                  }
                  this.companyInfoList.forEach((obj) => {
                    console.log(this['productlist' + obj.code], '12312313')
                    _.forEach(this['productlist' + obj.code], (value, index) => {
                      this.getSapCodeTh1(value, index);
                    });
                  });
                }
                //判断是否冷库
                ss.waixiao.isLk(obj.materialCode).then(rd => {
                  this.lkFlag = rd.msg;
                  console.log("lkFlag", this.lkFlag)
                })
              })
              // Promise.all([this.getCredit("9390"), this.getCredit("9370"), this.getCredit("1D90"), this.getCredit("1JC0"), this.getCredit("1RK0"), this.getCredit("9391")]).then(() => {
              //重新计算信贷
              //   this.companyInfoList.forEach((obj) => {
              //     if (this['order'+obj.code].creditid) {
              //       this.creditChange(this['order'+obj.code].creditid, obj.code);
              //     }
              //   })
              //原逻辑删除mark
              //  })
            })
          }
          if (rd.obj.isStandard == 2) {
            this.csFlag = true;
          }
        })
        console.log(this.order, '初始化数据')
        let value = {
          usercode: this.order.soldToCode,
          areaCode: rd.obj.salesregion,
        }
        ss.OrderMainService.getChannelByArea(value).then(rd => {
          console.log(rd);
          this.customerChannelListFilter = rd.msg;
          console.log(this.salesregionNameListFilter)
          if (this.customerChannelListFilter.length > 0) {
            //    this.order.customerChannelCode = null;
          } else {
            this.order.salesregion = null;
            this.order.customerChannelCode = null;
          }
        })
      })
    },
    viewpress (r) {
      this.showhistory = true;
    },
    backtolist () {
      this.$router.go(-1);
    },
    changeFinalPrice (value, index) {
      this['productlist' + value.gscode][index].proBenchmarkPrice = value.finalPrice;
    },
    keyupEvent(e,input){
      e.target.value=e.target.value.replace(/[^\d.]/g, '');
      e.target.value=e.target.value.replace(/\.{2,}/g, '.');
      e.target.value=e.target.value.replace(/^\./g, '0.');
      e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
      e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
      e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
      this.input=e.target.value
    },
    saveOrSubmit (v) {
      this.order.orderStatus = v
      if (v == '10') {
        this.order.submitflag = '暂存'
        this.order.newId = null
      } else if (v == '20') {
        this.order.submitflag = '提交'
        this.order.newId = null
      } else if (v == '30') {
        this.order.orderStatus = 20;
        this.order.newId = this.$route.query.ywid
        this.order.submitflag = '重新提报'
      }
      if (this.order.orderCategory1 == '6') {
        if (this.mfUrl == '' || this.mfUrl == null) {
          if (this.order.mfFileUrl == '' || this.order.mfFileUrl == null) {
            this.$msg.msge("请上传附件！");
            return;
          }
        }
      }
      var flag = true;
      //每次提交或者暂存将值清零 防止累加 hyl
      this.order.orderPrice = 0;
      this.order.orderPriceRbm = 0;


      this.companyInfoList.forEach((obj) => {
        _.forEach(this['productlist' + obj.code], (value, index) => {

          console.log(value, "this.submit")

          if (value.ycid == "" || value.ycid == null) {
            this.$msg.msge("请维护退货订单号！");
            flag = false;
            return;
          }
          //如果退货数量大于剩余数量
          if (value.proNumber <= 0) {
            this.$msg.msge("退货数量不能为0！");
            flag = false;
            return;
          }
          //如果退货数量大于剩余数量
          if (value.proNumber > value.surplusNum) {
            this.$msg.msge("退货数量大于剩余数量,请重新填写退货数量！");
            flag = false;
            return;
          }
          //如果成交价为0
          if (value.finalPrice <= 0) {
            this.$msg.msge("产品成交价不能为0或空！");
            flag = false;
            return;
          }
          //重新验证一遍退货订单号
          //如果退货的是买赠订单
          if (this.mzFlag) {

          } else {
            ss.OrderMainService.getSapCodeTh(value.ycid, value.materialCode).then(rd => {
              console.log(rd, "rd")
              if (!rd.f) {
                flag = false;
                return;
              }
            })
          }

          value.xdid = this['order' + obj.code].creditid
          value.totalpricermb = value.totalprice;
          value.costCenter = this.order['costCenter' + obj.code];

          this.order.orderPrice = new big(this.order.orderPrice || 0).plus(value.totalprice || 0);
          this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);


          //如果是分销商（二级经销商）成交价,净价值,计算总价 hyl
          if (this.secondAgent == true) {
            value.finalPrice = new big(value.specialPrice || value.expoPrice || value.proBenchmarkPrice * value.discount || value.proBenchmarkPrice).plus(value.extraPrice || 0).toFixed(2).toString()
            value.jinejjz = new big(value.finalPrice).div(value.taxRate).toFixed(2).toString()
            value.totalprice = new big(value.proNumber || 0).times((value.finalPrice || 0)).toFixed(2).toString()
          }


        });
      })

      //合并所有订单list
      this.order.products = [];
      this.companyInfoList.forEach((obj) => {
        this.order.products = this.order.products.concat(this['productlist' + obj.code]);
      })
      // this.order.products2 = this.productlist2;
      // this.order.products = this.productlist2;
      // this.order.salesregion = this.order.salesregionNew;

      if (flag) {
        if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
          //免费订单校验
          var freeflag = true;
          var companyFlag = true;

          if (this.showIsFree) {
            this.$refs['form0'].validate((valid0) => {
              freeflag = valid0;
            });
            //校验是否选择成本中心
            this.companyInfoList.forEach((obj) => {
              if (this['productlist' + obj.code].length > 0) {
                //因为el-form ref是动态生成的 会变成数组所以加[0]
                this.$refs['form' + obj.code][0].validate((valid0) => {
                  if (!valid0) {
                    companyFlag = valid0;
                    return false;
                  }
                });
              }
            })
            //原逻辑删除mark
            /* if (this.productlist9390.length > 0) {
                 this.$refs['form9390'].validate((valid0) => {
                     freeflag9390 = valid0;
                 });
             }

             }*/
          }

          this.$refs['form1'].validate((valid1) => {
            if (valid1 && freeflag && companyFlag) {
              this.$msg.confirm("确认提交？", () => {
                console.log(this.order)
                // console.log('我在这儿呀', this.order.orderPriceRbm,'4234324', this.order.orderPrice);
                if (this.zlUpdateFlag) {
                  this.updateZlOrder();
                } else {
                  this.submitForm();
                }
              })
            } else {
              this.$msg.msge("请完善基本信息后提交");
              return;
            }
          });
        } else {
          this.submitForm();
        }
      }

    },
    submitForm () {
      if (this.submitChongfuFlag) {

        if (this.order.tuihyydes == '' || this.order.tuihyydes == null) {
          this.order.tuihyydes = '检测'
        }
        // this.order.ydgFlag = this.ydgFlag;
        console.log(this.order)
        //标准订单和特殊订单
        if (this.order.category1Name == '标准订单' || this.order.category1Name == '特价订单') {
          //检测是否需要上传附件
          ss.OrderMainService.uploadCheck(this.order).then(res => {
            this.orderNu = res
            if (this.orderNu == 1 && this.order.isStandard == 1) {
              this.$message.error('此产品为冷库产品，请上传方案图纸和施工确认单');
              //
            } else if (this.orderNu == 1 && this.order.isStandard == 2) {
              this.$message.error('此产品为冷库产品，请上传方案图纸,施工确认单和投标参数');
            } else {
              ss.OrderMainService.checkDeliveryDay(this.order).then(res => {
                console.log(res)
                if (res.f == true) {
                  console.log(res)
                  this.submitChongfuFlag = false;
                  ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
                    this.submitChongfuFlag = true;
                    if (rd.f) {
                      if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                        this.$msg.msgs("提交成功！")
                        //二级经销商订单条二级经销商页面
                        if (this.agentLevel == 2) {
                          this.$router.push({ path: '/dingd/secondDingdmainlist' })
                        } else {
                          this.$router.push({ path: '/dingd/dingdmainlist' })
                        }

                      } else {
                        this.$msg.msgs("暂存成功！")
                      }
                    } else {
                      this.$msg.msge(rd.msg);
                    }
                  })
                } else {
                  this.$message.error(res.msg);
                }
              })
            }

          })


        } else {
          this.submitChongfuFlag = false;
          // 非标准订单，非特殊订单
          ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
            this.submitChongfuFlag = true;
            if (rd.f) {
              if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                this.$msg.msgs("提交成功！")
                //二级经销商订单条二级经销商页面
                if (this.agentLevel == 2) {
                  this.$router.push({ path: '/dingd/secondDingdmainlist' })
                } else {
                  this.$router.push({ path: '/dingd/dingdmainlist' })
                }

              } else {
                this.$msg.msgs("暂存成功！")
              }
            } else {

              this.$msg.msge(rd.msg);
            }
          })
        }
      } else {
        this.$msg.msge("重复点击提交，请稍后操作！");
      }
    },
    updateZlOrder () {

      if (this.submitChongfuFlag) {

        this.submitChongfuFlag = false;
        // 非标准订单，非特殊订单
        ss.OrderMainService.commitContainer(this.order).then(rd => {

          this.submitChongfuFlag = true;

          if (rd.f) {

            if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {

              this.$msg.msgs("提交成功！")

              this.$router.push({ path: '/dingd/dingdmainlist' })

            } else {

              this.$msg.msgs("暂存成功！")

            }

          } else {

            this.$msg.msge(rd.msg);

          }
        })
      } else {

        this.$msg.msge("重复点击提交，请稍后操作！");

      }
    },
    resaveOrSubmit (v) {
      this.saveOrSubmit(30);
      // this.order.orderStatus = v
      // this.$msg.confirm("确认提交？", () => {
      //     this.order.submitflag = '重新提报'
      //     ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
      //         this.$router.push({path: '/dingd/dingdmainlist'})
      //     })
      // })
    },
    getShoudafang (usercode) {
      if (!usercode) {
        if(this.guanliren){
          this.order.receivedTime = this.$util.formatDate(this.$util.addDays(new Date(), 5))
        }
        return "";
      }
      return ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
        this.choseshoudf(rd, true);
      })
    },
    //查询用户，用户余额，所有信贷
    getCredit (gscode) {
      var params = {};
      // console.log(this['productlist' + gscode])
      // console.log(_.map(this['productlist' + gscode], "proModelCode"))
      //列表中的第一个的产品大类
      var cpdl = _.uniq(_.map(this['productlist' + gscode], "proModelCode"));
      if (cpdl.length == 1) {
        params.cpdlcode = cpdl[0];
      }
      params.salegroupcode = gscode;
      params.usercode = this.order.soldToCode;
      // console.log(params)
      return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
        console.log("信贷", rd)
        this['order' + gscode].creditData = rd.xd;
        this['order' + gscode].xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
      })
    }
    ,
    //修改共享大类
    changeShareModel (scode, row) {
      console.log(scode);
      if (row.shareModelCode) {
        const smobj = _.find(row.smList, { shareModelCode: row.shareModelCode })
        row.shareModelName = smobj.shareModelName;
        console.log(row.shareModelName);
      } else {
        row.shareModelName = null;
      }
    },
    //特价改变
    changeTejia (scode, row) {
      console.log('特价改变', scode, row)
      if (row.specialOfferCode) {
        const tjobj = _.find(row.tjlist, { tjdtid: row.specialOfferCode })
        row.specialPrice = tjobj.tejia;
        row.specialPriceNum = tjobj.sysl;
        row.tjid = tjobj.tjid;
        row.tjdtid = tjobj.tjdtid;

      } else {
        row.specialOfferCode = null;
        row.specialPrice = null;
        row.specialPriceNum = null;
        row.tjid = null;
        row.tjdtid = null;

      }
    },
    getProductlist (code) {
      // console.log("productlist"+code,this[`${'productlist' + code}`].length)
      return this['productlist' + code];
    },
    getRentPrice (v, index) {
      if (v.priceType == 'ZL03' || v.priceType == 'ZL05') {
        var contractSDate = new Date(this.contract.contractStarttime);
        var nowDate = new Date();
        //若合同已开始执行并需要调整租赁时间
        /*                    if(contractSDate.getTime() <= nowDate.getTime()){
                                this.$msg.msge("合同已开始执行，不允许选择当前费用类型！");
                                return;
                            }*/
      }
      var repeatFlag = false;
      //租赁费的话,根据租赁类型和租赁天数获取租赁价格
      if (v.priceType == 'ZL01') {
        if (this.zulinPrice != '' && this.zulinPrice != null) {
          this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = this.zulinPrice;
        } else {
          this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = 0;
        }
        //根据费用类型和天数获取价格
        var data = {
          rentType: null,
          rentTerm: 0,
        }
        data.rentType = this.contract.rentType;
        data.rentTerm = this.contract.rentTerm;
        ss.contractService.selectRentTimeByType(data).then(rd => {
          if (rd.f) {
            this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = rd.msg[0].rentPrice;
          }
        })
      } else {
        //根据费用类型获取价格
        var data = {
          priceType: null,
          isShhm: 0,
          isJj: 0,
        }
        data.priceType = v.priceType;
        if (data.priceType == 'ZL05') {
          data.isJj = 1;
        } else if (data.priceType == 'ZL08') {
          data.isShhm = 1;
        }
        ss.contractService.selectByRentType(data).then(rd => {
          if (rd.f) {
            var list = rd.msg;
            if (v.priceType == 'ZL04') {
              //判断合同是执行中还是开始前两天
              var contractSDate = new Date(this.contract.contractStarttime);
              var nowDate = new Date();
              //若合同已开始执行并需要调整租赁时间
              if (contractSDate.getTime() <= nowDate.getTime()) {
                this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = list[0].allPrice;
              } else {
                this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = list[0].untiPrice;
              }
            } else {
              this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = list[0].untiPrice;
            }

          }
        })
      }
    },
    changeArea (query) {
      console.log("接受到的参数", query);
      //根据选择的销售区域带出对应的渠道

      let value = {
        usercode: this.order.soldToCode,
        areaCode: query
      }
      ss.OrderMainService.getChannelByArea(value).then(rd => {
        console.log(rd);
        this.customerChannelListFilter = rd.msg;
        console.log(this.salesregionNameListFilter)
        if (this.customerChannelListFilter.length > 0) {
          //    this.order.customerChannelCode = null;
        } else {
          this.showshdfdialog = false
          this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
          return;
        }
      })
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })
      this.order.customerChannelCode = '';
      this.selectMz = false;
    },
    //清空已选产品列表
    cleanOrder () {
      console.log('客户渠道发生变化!')

      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })
      this.selectMz = false;

      this.productlist2 = [];
      if (this.showJzx) {
        //如果租赁合同中只包含一个产品，则直接带出 wxwl
        let proList = {};
        if (this.contract.zlList) {
          var list = this.contract.zlList;
          //根据产品编码去重
          list = list.reduce((total, currentValue) => {
            proList[currentValue.productCode] ? '' : proList[currentValue.productCode] = total.push(currentValue);
            return total
          }, [])
          if (list.length == 1) {
            var data = {};
            var proData = {};
            data.usercode = this.order.soldToCode;
            data.ddlx = this.ddlx;
            data.xmcode = this.order.orderMainContract;
            data.currencyCode = this.order.currencyCode;
            data.customerChannelCode = this.order.customerChannelCode;
            data.wlcodename = list[0].productCode;
            ss.wuliaoselect.selectPage(data).then(rd => {
              proData = rd.records;

            })
          }
        }
      }
    },

    //选择售达方
    openShoudf () {
      this.showshdfdialog = true;
    },
    choseshoudf (obj, changeflag) {

      console.log('1234-->', obj)
      //                设置客户渠道，
      //                 this.customerChannelListFilter = _.split(obj.khqd,",");
      //                 if(this.customerChannelListFilter.length>0){
      //                     this.order.customerChannelCode=obj.khqd;
      //                 }else{
      //                     this.showshdfdialog = false
      //                     this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
      //                     return;
      //                 }

      //直单用户flag
      this.zhidanflag = obj.zhidanflag;
      this.companycodes = obj.companycodeBas;
      this.isBlood = obj.isBlood;
      //是否直单用户根据签约的公司进行选择
      this.zhidanCompanycode = [];
      this.zhidanGsCode = '';
      //设置经销商级别
      this.agentLevel = obj.agentLevel;
      this.order.agentLevel = obj.agentLevel;
      //是否直单用户并且内销标准订单 可选择公司
      console.log("类型", this.ddlx);
      this.selectMz = false;


      this.chooseGscode = false;
      console.log("公司代码：" + this.companycodes);
      console.log("是否血站渠道：" + this.isBlood);
      console.log("订单主数据", this.order);
      // 设置客户渠道，
      //如果是工程订单
      this.salesregionNameListFilter = _.filter(this.salesregionNameList, (o) => {
        return _.split(obj.salesregion || '', ",").includes(o.code);
      });
      // 清空物料
      if (this.order.soldToCode != obj.usercode) {
        this.companyInfoList.forEach((obj) => {
          this['productlist' + obj.code] = [];
        })
        this.productlist2 = [];
      }
      //如果是A33客户（青岛海尔特种电器有限公司一次性客户） 此字段应于判断样品机订单 A33客户的打折级别
      if (obj.usercode == 'A33') {
        this.isA33 = true;
      } else {
        this.isA33 = false;
      }
      this.order.soldToName = obj.username;
      this.order.soldToCode = obj.usercode;
      this.order.soldToAreaCode = obj.area;
      this.order.soldToAreaName = obj.areaname;
      /*  this.order.salesregion = obj.salesregion;
        this.order.salesregionName = obj.salesregionName;*/
      this.order.gjmytk = obj.gjmytk; //国际贸易条款
      this.order.fktj = obj.fktj; //付款条件
      this.order.currencyCode = (changeflag ? this.order.currencyCode : obj.currency) || 'CNY';
      this.showshdfdialog = false;

      // this.order.customerChannelCode = null;
    },

    //删除该行项目产品信息
    deleteThis2 (row) {
      var id = row.id;
      if (this.productlist2.length == 1) {
        this.$msg.msge("至少保留一个退回产品！")
        return;
      }
      this.$msg.confirm("确认删除？", () => {
        this.productlist2 = _.reject(this.productlist2, { 'id': id });
      })
    },

    //选择物料
    showProcuct2 () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      if (this.selectMz) {
        this.$msg.msge("买赠订单只可选择一笔订单！")
        return;
      }
      this.showwuliaodialog1 = true;
    },
    showProcuct3 () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      this.showwuliaodialog2 = true;
    },
    //选择物料
    choseWuliao1 (objs) {
      console.log("选中的物料", objs)
      this.showwuliaodialog1 = false;
      this.showwuliaodialog2 = false;
      for (var i = 0; i < objs.length; i++) {
        var addwl = objs[i];
        var wl = this.wlToProject(addwl);
        //添加行项目
        this.addProject(wl);
        this.changeTejia("1", wl);
        var lkData = wl.materialCode;
        //判断选中的产品是否是冷库产品
        ss.waixiao.isLk(lkData).then(rd => {
          this.lkFlag = rd.msg;
          console.log("lkFlag", this.lkFlag)
          //如果是冷库产品,则在新增时需先生成一个虚拟的预测单号用于绑定附件,点击预测单提交时更新绑定真实的预测单编号
        })
      }
      //获取遍历公司调用getCredit方法
      Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
        this.companyInfoList.forEach((obj) => {
          this['order' + obj.code].creditid = this['order' + obj.code].creditData.length > 0 ? _.first(this['order' + obj.code].creditData).id : null;
          this['order' + obj.code].orderPriceXd = 0;
        })
        //原逻辑删除mark
      })

    },

    choseOrder (query) {
      //根据订单号查询物料
      this.showwuliaodialog1 = false;
      ss.wuliaoselect.selectOrderTh(query[0].sapCode).then(rd => {
        if (rd.f) {
          this.selectMz = true;
          let objs = [];
          for (let item of rd.msg) {
            objs.push(item)
          }
          this.choseWuliao1(objs);
        }
      })
    },

    addProject (obj) {
      console.log("oooobbbbjjjj", obj);
      console.log(obj.id + "行项目");
      var alllist = []
      //合并所有订单list
      this.companyInfoList.forEach((obj) => {
        alllist = alllist.concat(this['productlist' + obj.code]);
      })

      console.log("alllist", alllist)

      if (!this.order['costCenter' + obj.gscode]) {
        this.order['costCenter' + obj.gscode] = obj.costCenter || null;
      }

      this['productlist' + obj.gscode].push(obj);
      this['order' + obj.gscode].creditid = obj.xdid;
      console.log("this['productlist' + obj.gscode]", this['productlist' + obj.gscode])
    },
    wlToProject (obj) {
      var wl = {};
      wl.id = this.$util.getUuid();
      wl.materialCode = obj.matecode;//物料编码
      wl.materialName = obj.matedes;//物料名称
      wl.proModelCode = obj.cpdlcode;//产品型号编码
      wl.proModelName = obj.cpdlname;//产品型号名称
      wl.cpz = obj.cpz; //产品组
      wl.dwcode = obj.dwcode;//单位
      wl.dwname = obj.dwname;//单位
      wl.currencyCode = obj.currency;//币种编码
      wl.ycid = obj.sapCode;
      if (this.mzFlag) {
        //如果是买赠订单是所有的数量一起退
        wl.finalPrice = obj.finalprice;
        wl.proBenchmarkPrice = obj.finalprice
        wl.jinejjz = obj.jinejjz
        wl.proNumberTh = obj.proNumber;
        wl.surplusNum = obj.proNumber - obj.num;
        wl.proNumber = obj.proNumber;
        wl.totalprice = obj.totalprice
      }
      if (obj.taxCat != null && obj.taxCat != '') {
        wl.taxCat = obj.taxCat;//税分类
      } else {
        this.$msg.msge("税分类不能为空！");
        return;
      }
      wl.field = obj.field;//选择产品所在的领域
      wl.orderField = obj.field;//选择产品所在的领域
      //税率
      if (wl.taxCat == '2' || wl.taxCat == '3' || wl.taxCat == '4') {
        wl.taxRate = 1.13;
      } else if (wl.taxCat == '7') {
        wl.taxRate = 1.06;
      } else {
        wl.taxRate = 1;
      }

      if (this.contract.contractAmount != null) {
        wl.proBenchmarkPrice = this.contract.contractAmount;
        // wl.proNumber = this.contract.rentNum;

        if (this.contract.zlList) {
          if (this.contract.zltype != '3') {
            this.contract.zlList.forEach((obj) => {
              if (wl.materialCode == obj.productCode) {
                wl.proNumber = 1;
                wl.proNumber1 = obj.rentNum;
                wl.proBenchmarkPrice = obj.productUnitPrice;//产品基准价
              }
            })
          }
          if (this.contract.zltype == '3') {
            wl.rentSort = null;
          }
          wl.zltype = this.contract.zltype;
          wl.priceType = null;
        }


      } else if (!this.mzFlag) {
        wl.proNumber = 0;//产品数量
        wl.proBenchmarkPrice = obj.jizhj;//产品基准价
      }
      wl.specialOfferCode = null; // 特价版本
      wl.specialPrice = null; // 特价价格
      wl.specialPriceNum = null; // 特价价格
      wl.tjid = null; // 特价id
      wl.tjdtid = null; // 特价蛋疼id
      wl.isCustommed = 0; // 是否定制     1：是   0 否
      wl.extraPrice = null; // 定制加价
      wl.extraDes = null; // 定制需求
      wl.cwddh = null;

      wl.gscode = obj.companycode; //公司编码
      this.ypjFlag = false;
      wl.proType = obj.protype; //自产还是oem
      wl.cgprice = obj.cgprice; //采购价
      wl.cgmll = obj.cgmll; //采购毛利率
      wl.shareModelCode = null;
      wl.shareModelName = null;

      if (!this.mzFlag) {
        wl.finalPrice = 0;//成交价
        wl.totalprice = 0;//产品总价
        wl.isMaizeng = 0;
      } else {
        wl.isMaizeng = 1;
      }
      wl.tjlist = obj.tjlist;//特价list
      wl.expoPrice = obj.expoPrice;
      wl.fromtype = obj.fromtype;

      //2021,12,28 zk 新增共享大类list
      wl.smList = obj.smList;

      wl.factory = obj.factory;
      wl.cpdlcode = obj.cpdlcode;

      wl.xiaoe = obj.xiaoe;
      wl.jishu = obj.jishu;
      wl.lianqun = obj.lianqun;
      wl.oemDesc = obj.oemDesc;
      if(this.guanliren&&wl.proType=='OEM'){
        wl.zhifakufa = 2
      }
      return wl;
    },
    //选择地址
    selectAreadialog () {
      this.showdizhiflag = true;
    },
    choseDizhi (obj) {

      console.log("选中的地址", obj)
      this.order.addressCode = obj.id;
      this.order.areaId = obj.id;
      this.order.toAddress = obj.quobj.namepath;
      if (obj.zhenobj) {
        // this.order.toAddress = obj.zhenobj.namepath;
        obj.addrdetail = obj.zhenobj.name + "/" + obj.addrdetail;
      }
      this.order.toAddress = this.order.toAddress + "##" + obj.addrdetail

      this.order.toProvincesCode = obj.shengobj.code;
      this.order.toProvincesName = obj.shengobj.name;

      this.order.toCityCode = obj.shiobj.code;
      this.order.toCityName = obj.shiobj.name;

      this.showdizhiflag = false;


      //清空时间
      this.order.receivedTime = null;
      this.openReceivedTimedisabled = false;
      //根据地址，获取预计收货时间
      // ss.OrderMainService.getSendDays(obj.qu).then(rd => {
      //     console.log(rd);
      //     this.startDateLimit = _.assign({}, this.startDateLimit, {
      //         disabledDate: (time) => {
      //             return time.getTime() < new big(rd).plus(2).times(24 * 60 * 60 * 1000).plus(Date.now()).toString()
      //         }
      //     })
      // })
    },

    //直单用户修改公司 hyl
    chooseGsCode (code) {
      //将其他公司的数据赋值给选择的公司
      this.companyInfoList.forEach((obj) => {
        if (obj.code != code) {
          this['productlist' + obj.code].forEach((obj) => {
            this['productlist' + code].push(obj);
          })
          //清空其他公司信息
          this['productlist' + obj.code] = [];
        }
      })
      //将所有物料的公司编码改成选择的
      for (var i = 0; i < this['productlist' + code].length; i++) {
        this['productlist' + code][i].gscode = code;
      }

    },
    //获取收货单位
    showFormList (value) {
      // console.log("value188776676","111111111111111111111111")
      var data = value;
      console.log("value188776676", data)
      ss.OrderMainService.getCompanyInfo(value).then(rd => {
        this.addrList = rd;
      })
    },

    //新增收货单位
    createAddress () {
      this.titleDig = "新建收货单位"
      this.institutionalX = true
      /*this.loadArea();*/
    },
    closeCompanyName (propData) {
      console.log(propData);
      this.closeDialog();
    },
    loadArea (i) {
      ss.Dictservice.arealist(this.proSelect).then(rd => {
        this.shenglist = rd;
        // for(let i = 0; i < this.shenglist.length; i++){
        //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
        // }
        console.log("shenglist", this.shenglist)
      })
    },
    //取消
    exit () {
      this.closeDialog()
    },
    //关闭弹窗,清空数据
    closeDialog () {
      this.institutionalX = false
      this.newDialog = false
      this.updateDialog = false
      this.insertFlag = false
      this.reFlag = false
      //清空数据
      this.add.deptName = '';
      this.add.deptType = '';
      this.add.phone = '';
      this.add.leader = '';
      this.add.email = '';
      this.add.province = '';
      this.add.provinceId = '';
      this.add.city = '';
      this.add.cityId = '';
      this.add.area = '';
      this.add.areaId = '';
      this.add.landmark = '';
      this.add.address = '';
      this.add.parentCode = '';
      this.add.deptSourceChannel = '';
      this.stVal = null;
      this.add.schoolTypeName = '';
    },
    //关闭弹窗,清空数据
    closePriceDialog () {
      this.selectPriceDialog = false;
      this.zlPrice.pricetype = null;
    },
    exitPrice () {
      this.closePriceDialog();
    },
    commitPriceType () {
      var selectType = this.zlPrice.pricetype;
      //获取费用
      //根据费用类型获取价格
      var entity = {
        priceType: null,
        isShhm: 0,
        isJj: 0,
      }
      entity.priceType = this.zlPrice.pricetype;
      if (entity.priceType == 'ZL05') {
        entity.isJj = 1;
      } else if (entity.priceType == 'ZL08') {
        entity.isShhm = 1;
      }
      ss.contractService.selectByRentType(entity).then(rd => {
        if (rd.f) {
          var list = rd.msg;
          var newList = [];
          var zulinOrder = this['productlist' + this.zhidanGsCode][0];
          var zulinOrder1 = JSON.parse(JSON.stringify(zulinOrder));
          if (this['productlist' + this.zhidanGsCode].length == 1) {
            zulinOrder.priceType = this.zlPrice.pricetype;
            zulinOrder.proBenchmarkPrice = list[0].untiPrice;
            zulinOrder.id = this.$util.getUuid();
            zulinOrder.rentSort = 1;
            this['productlist' + this.zhidanGsCode].push(zulinOrder);
          } else if (this['productlist' + this.zhidanGsCode].length > 1) {
            newList.push(zulinOrder);
            for (var i = 1; i < this['productlist' + this.zhidanGsCode].length; i++) {
              var data = this['productlist' + this.zhidanGsCode][i];
              var data1 = this['productlist' + this.zhidanGsCode][i - 1];
              if (zulinOrder.priceType == data.priceType) {
                zulinOrder1.priceType = selectType;
                zulinOrder1.proBenchmarkPrice = list[0].untiPrice;
                zulinOrder1.id = this.$util.getUuid();
                zulinOrder1.rentSort = data1.rentSort;
                newList.push(zulinOrder1);
                newList.push(data);
              } else if (i == this['productlist' + this.zhidanGsCode].length - 1) {
                newList.push(data);
                zulinOrder1.priceType = selectType;
                zulinOrder1.proBenchmarkPrice = list[0].untiPrice;
                zulinOrder1.id = this.$util.getUuid();
                zulinOrder1.rentSort = data.rentSort;
                newList.push(zulinOrder1);
              } else {
                newList.push(data);
              }

            }
            this['productlist' + this.zhidanGsCode] = newList;
            console.log("pppppprrrrrrooooo", this['productlist' + this.zhidanGsCode])
          }

        }
      })
      //添加

      //关闭弹窗
      this.closePriceDialog();
    },
    //省份选择器
    handleItemChange1 (o) {
      this.add.provinceId = o;
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        console.log("rddddddd", rd.zlist)
        this.add.city = '';
        this.add.area = '';
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
      })
    },
    handleItemChange2 (o) {
      this.add.cityId = o;
      this.address = _.find(this.arealist2, { code: this.add.cityId });
      this.add.city = this.address.name;
      this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      console.log("arealist3", this.arealist3)
      this.arealist4 = []
    },
    handleItemChange3 (o) {
      this.add.areaId = o;
      this.address = _.find(this.arealist3, { code: this.add.areaId });
      this.add.area = this.address.name;
    },
    commitCreate (v) {
      this.add.subFlag = '提交';
      this.add.countryId = '156';
      this.add.country = '中国';
      this.add.provinceId = this.add.provinceId.substring(0, 6);
      this.add.cityId = this.add.cityId.substring(0, 6);
      this.add.areaId = this.add.areaId.substring(0, 6);
      this.add.parentCode = this.stVal;

      var data = this.add;
      ss.nxAddress.insertAddress(data).then(rd => {
        this.closeDialog();
        this.query();
      })
    },
    //获取单位名称信息
    selectDept (value) {
      ss.nxAddress.getDeptList(value).then(rd => {
        this.deptNameList = rd.msg;
      })
    },
    //获取当前登录人创建的所有父级单位
    getParentInfo () {
      ss.nxAddress.getParentInfo().then(rd => {
        this.options = rd.msg;
      })
    },
    getRentTime () {
      var data = {
        rentType: null,
      }
      let that = this;
      if (that.contract.rentType) {
        data.rentType = this.contract.rentType;
        ss.contractService.selectRentTimeByType(data).then(rd => {
          if (rd.f) {
            that.rentTimeList = rd.msg;
            /*                            that.formInline.rentTime = that.rentTimeList[0].rentTerm;// 默认租赁天数
                                        that.formInline.contractStarttime = that.timestampToTime(new Date().getTime());// 默认开始日期
                                        that.formInline.contractEndtime = that.timestampToTime(new Date().getTime()+that.formInline.rentTime*24*60*60*1000);
                                        that.formInline.rentPrice = that.rentTimeList[0].rentPrice;*/
          }
        })
      }
    },
    // 时间戳转换日期
    timestampToTime (timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear();
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let D = date.getDate().toString().padStart(2, 0);
      let h = date.getHours() + ':';
      let m = date.getMinutes() + ':';
      let s = date.getSeconds();
      return Y + '-' + M + '-' + D;//+h+m+s
    },
    //渠道改变
    changeChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value.code).then(rd => {
        this.addressTypeList = rd.msg;
        this.add.schoolTypeName = '';
      })
    },
    changeSchoolType (value) {
      this.add.schoolTypeName = value;
    },
    getSapCodeTh (value, index) {
      var ycid = this['productlist' + value.gscode][index].ycid;
      ss.OrderMainService.getSapCodeTh(ycid, value.materialCode).then(rd => {
        console.log(rd, "rd")
        if (rd.f) {
          this['productlist' + value.gscode][index].proNumberTh = rd.msg.proNumber;
          //基准价取成交价,不然传sap报错
          this['productlist' + value.gscode][index].proBenchmarkPrice = rd.msg.finalPrice;
          this['productlist' + value.gscode][index].surplusNum = rd.msg.proNumber - rd.msg.num;
          this['productlist' + value.gscode][index].finalPrice = rd.msg.finalPrice;
          this['productlist' + value.gscode][index].ycid = rd.msg.sapCode;
        } else {
          this['productlist' + value.gscode][index].proNumber = '';
        }
      })
    },
    deleteThis (row) {
      console.log(row, "删除");
      if (this.mzFlag) {
        //判断是不是产品价格为0的
        if (row.proBenchmarkPrice == 0) {
          var id = row.id;
          var gscode = row.gscode;
          this.$msg.confirm("确认删除？", () => {
            this['productlist' + gscode] = _.reject(this['productlist' + gscode], { 'id': id });
            //合并所有订单list
            this.order.products = [];
            this.companyInfoList.forEach((obj) => {
              this.order.products = this.order.products.concat(this['productlist' + obj.code]);
            })
            // 删除的时候,没有一个了，肯定是false
            this.ydgFlag = this.order.products.length == 0 ? false : this.ydgFlag;
          })
        } else {
          this.$msg.confirm("确认删除？", () => {
            this.companyInfoList.forEach((obj) => {
              this['productlist' + obj.code] = [];
            })
          })
          this.selectMz = false;
        }
        return;
      }
      var id = row.id;
      var gscode = row.gscode;
      this.$msg.confirm("确认删除？", () => {
        this['productlist' + gscode] = _.reject(this['productlist' + gscode], { 'id': id });
        //合并所有订单list
        this.order.products = [];
        this.companyInfoList.forEach((obj) => {
          this.order.products = this.order.products.concat(this['productlist' + obj.code]);
        })

        // 删除的时候,没有一个了，肯定是false
        this.ydgFlag = this.order.products.length == 0 ? false : this.ydgFlag;
      })
    },
    getSapCodeTh1 (value, index) {
      this.Productlistloading = true
      ss.OrderMainService.getSapCodeTh(value.ycid, value.materialCode).then(rd => {
        console.log(rd, "rd")
        if (rd.f) {
          this.Productlistloading = false
          this['productlist' + value.gscode][index].finalPrice = rd.msg.finalPrice;
          //基准价取成交价,不然传sap报错
          this['productlist' + value.gscode][index].proBenchmarkPrice = rd.msg.finalPrice;
          this.$set(this['productlist' + value.gscode][index], 'proNumberTh', rd.msg.proNumber);
          this.$set(this['productlist' + value.gscode][index], 'surplusNum', rd.msg.proNumber - rd.msg.num);
        } else {
          this['productlist' + value.gscode][index].proNumber = '';
        }
      })
    },
    //根据公司编码返回OrderName
    getOrderName (code) {
      return this['order' + code];
    },
    changeDeptName (val) {
      console.log("changeDeptName", val)
      //匹配省市区信息
      ss.nxAddress.getAddressByWl(val).then(rd => {
        if (rd.f == true) {
          this.add.provinceId = rd.msg.provinceId;
          this.add.province = rd.msg.province;
          this.add.cityId = rd.msg.cityId;
          this.add.city = rd.msg.city;
          this.add.areaId = rd.msg.areaId;
          this.add.area = rd.msg.area;
          this.add.address = rd.msg.address;
          this.handleItemChangeN(this.add.provinceId);
        }
      })
      //根据单位名称获取关键字
      ss.nxAddressKeywords.matchKeywords(val).then(rd => {
        if (rd.msg != null) {
          this.add.deptSourceChannel = rd.msg.channelCode;
          this.add.schoolTypeName = rd.msg.userUnit;
          this.matchChannel(rd.msg.channelCode)
        }
      })
    },
    matchChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value).then(rd => {
        this.addressTypeList = rd.msg;
        // this.add.schoolTypeName = '';
      })
    },
    //地址选择器-新
    handleItemChangeN (o) {
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      // this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
        this.address = _.find(this.arealist2, { code: this.add.cityId });
        // this.add.city = this.address.name;
        this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      })
    }

  }
}
</script>
<style scoped>
.queren {
  background-color: #006aca;
  color: white;
}

.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.zancun {
  background-color: #24b5b8;
  color: white;
}

.quxiao,
.zancun {
  width: 100px;
}

.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}

.jieguo .jieguo_label {
  width: 2rem;
  text-align: right;
  background-color: #ebf5ff;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.05rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jieguo .jieguo_value {
  width: 19%;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0px 8px;
}

img {
  width: 25px;
  padding: 5px 0;
}

.DshuR {
  width: 100%;
  height: 100%;
  border: none;
}

.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}
.n-xiao .h-formbLine .h-elformWrap-z,
.n-two .h-formbLine .h-elformWrap-z {
  width: 29%;
}
.n-xiao .h-formbLine .h-elformWrap-m,
.n-two .h-formbLine .h-elformWrap-m {
  width: 2%;
}
</style>
<style>
.n-two .h-formbLine .el-form-item__content .el-select,
.n-two .el-form .h-formbLine .el-form-item__content .el-select {
  width: 0;
}

.n-xiao .h-formbLine .el-form-item__label,
.n-two .h-formbLine .el-form-item__label {
  width: 43%;
}

.n-xiao .h-formbLine .el-form-item__content,
.n-two .h-formbLine .el-form-item__content {
  width: 57%;
}

.ljjtablepaddings2 .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}
.ljjtablepaddings2 .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}
.ljjtablepaddings2 .ljjsales .el-input__inner {
  height: 0.3rem;
  line-height: 0.3rem;
}
.w-newIcon .el-input__icon {
  line-height: 0.4rem !important;
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
  z-index: 999999;
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785e7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .createNxs {
    position: absolute;
    z-index: 1;
  }

  .createNx1 {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .createNxbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #ffffff;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.75rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.4rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
    z-index: 2;
  }
}
</style>
